import { render, staticRenderFns } from "./incidents-types-grid.vue?vue&type=template&id=640ebf76&scoped=true&"
import script from "./incidents-types-grid.ts?vue&type=script&lang=ts&"
export * from "./incidents-types-grid.ts?vue&type=script&lang=ts&"
import style0 from "./incidents-types-grid.scss?vue&type=style&index=0&id=640ebf76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ebf76",
  null
  
)

export default component.exports